// Shared status lists + Tailwind styles for purchase fulfillment/payment tags,
// so the Purchase Status Board and the purchase detail render identical pills.
export const FULFILLMENT_STATUSES = ['fabrication', 'waiting_transport', 'transport', 'customs', 'expresit', 'arrived']
export const FULFILLMENT_STYLE = {
  fabrication:        'bg-sky-100 text-sky-700',
  waiting_transport:  'bg-amber-100 text-amber-700',
  transport:          'bg-indigo-100 text-indigo-700',
  customs:            'bg-purple-100 text-purple-700',
  expresit:           'bg-cyan-100 text-cyan-700',
  arrived:            'bg-emerald-100 text-emerald-700',
}
export const PAYMENT_STATUSES = ['pending', 'paid']
export const PAYMENT_STYLE = {
  pending: 'bg-amber-100 text-amber-700',
  paid:    'bg-green-100 text-green-700',
}
export const PILL_FALLBACK = 'bg-gray-100 text-gray-600'
